import React, { useEffect, useRef, lazy } from 'react';
interface GalleryImage {
  src: string;
  alt: string;
}
export const SlidingGallery = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  // All gallery images from the Gallery page
  const galleryImages: GalleryImage[] = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mStosbmgsDJZaVNXWK79Vp/IMG-20241230-WA0235.jpg',
    alt: 'Networking participants at Abuja 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ap4bmaPe9hmEptZ6WsRMrf/IMG-20241230-WA0241.jpg',
    alt: 'Participants at Abuja 2024 event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iDwtrQyjqxo85W3ty8cyfb/IMG-20241230-WA0255.jpg',
    alt: 'Networking at Abuja 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xnN9ZhpkVeKWdkMVpHza9P/IMG-20241230-WA0257.jpg',
    alt: 'Participants at Abuja 2024 event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ukzdn4cZkNVnrwX98CEf3t/IMG-20241230-WA0285.jpg',
    alt: 'Networking at Abuja 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sPMQ7cKtgN3BLeiHF9y8Kn/SAV_8260.jpg',
    alt: 'Benin January 2024 networking event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vqYAu12xeCB8m1eJ25tfZh/SAV_8332.jpg',
    alt: 'Presenter at Benin January 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pKFWp4VC5e3Pwz9v6vhjBR/SAV_8448.jpg',
    alt: 'Group at Benin January 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fUrvThWdJVSVsYbHQSSyQ8/SAV_8518.jpg',
    alt: 'Group photo Benin January 2024'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1gwke6zSyiBgy5sWBe6ogs/SAV_8246.jpg',
    alt: 'Networking at Benin January 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    alt: 'Benin 2024 networking event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aftEvNay6iufkLwXy7PyxK/1755202597036.jpg',
    alt: 'Participants in Benin 2024'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tiV51YTW2Kgksy4S6DCFzv/9E5A0115.jpg',
    alt: 'Speaker at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdYASKwaTWbg8Zeg4zbzfL/9E5A0116.jpg',
    alt: 'Attendees at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1o2JxTTB5rd1HeQtR4QeD5/SAV_8246.jpg',
    alt: 'Networking at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e4tPqZYswWdLwYmJt2uJ4H/SAV_8260.jpg',
    alt: 'Handshake at Benin 2024 event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nYwfv4bFC8ShRoMKyHwPW9/SAV_8309.jpg',
    alt: 'Speaker at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ieFEvEtnDSK8Bs5n6SjPUf/SAV_8332.jpg',
    alt: 'Presenter at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tJLvYiUA6HseBucNGeHbTB/SAV_8448.jpg',
    alt: 'Group at Benin 2024 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/252LSHK84ggBH7aCLZhcgc/a24.jpg',
    alt: 'Benin 2022 networking event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dRteZgab5q3tv2y2YjKb1E/a27.jpg',
    alt: 'Group photo Benin 2022'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cxb3FJEMV3mP9TXwBXyfRv/a18.jpg',
    alt: 'Speaker at Benin 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aW7ysQsfvZg1F186uWgoYf/a14.jpg',
    alt: 'Participant at Benin 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dkQDRJ84X5BmuvWQ7w3CHQ/a9.jpg',
    alt: 'Sharing at Benin 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hqCpx22Yii18MU7bJ8Fsfi/IMG-20220824-WA0124.jpg',
    alt: 'Evening event Abuja 2022'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hXxv7SzVH7sPyDUKohjgSX/IMG-20220824-WA0152.jpg',
    alt: 'Participant at Abuja 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gpSxYfExm72etV9WcMUv11/IMG-20220824-WA0156.jpg',
    alt: 'Speaker at Abuja 2022 event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jwHMdt32zhXEViJa4g921W/IMG-20220824-WA0087.jpg',
    alt: 'Engaging at Abuja 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pGv9Amrjjy2zTAP2t23RNP/IMG-20220824-WA0081.jpg',
    alt: 'Discussion at Abuja 2022 salon'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ciCFjhcNKhhvWPuNF4wxL/Network_Scoot.jpg',
    alt: 'Networking in Lagos 2025'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gumJfCcrUgAhRz8naofitq/Network_tobi.jpg',
    alt: 'Discussion in Lagos 2025'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/62DL8VzUWoZSsys88qcCmf/speaking_anne.jpg',
    alt: 'Speaker in Lagos 2025'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    alt: 'Group photo Lagos 2025'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    alt: 'Five women Lagos 2025'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    alt: 'Four people Lagos 2025'
  }];
  // Duplicate images for seamless loop
  const duplicatedImages = [...galleryImages, ...galleryImages];
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let animationFrameId: number;
    let scrollPosition = 0;
    const scrollSpeed = 0.5; // pixels per frame
    const animate = () => {
      scrollPosition += scrollSpeed;
      // Reset scroll position when we've scrolled through one set of images
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scrollContainer.scrollLeft = scrollPosition;
      animationFrameId = requestAnimationFrame(animate);
    };
    animationFrameId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <section className="py-16 border-b-2 border-gray-300 overflow-hidden" style={{
    backgroundColor: '#F9F9F9'
  }} data-id="element-626" data-mp="gxo0mg075btw">
      <div className="container mx-auto px-4 mb-8" data-id="element-627" data-mp="byuux9r5ip4a">
        <h2 className="text-3xl md:text-4xl font-bold text-center" style={{
        color: '#0B1F3F'
      }} data-id="element-628" data-mp="701hfhbv6y44">
          Our Salons Around the World
        </h2>
      </div>

      <div ref={scrollRef} className="flex gap-4 overflow-x-hidden" style={{
      scrollBehavior: 'auto',
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-629" data-mp="23ay8l4rjmeh">
        {duplicatedImages.map((image, index) => <div key={`${image.src}-${index}`} className="flex-shrink-0 w-80 h-64 rounded-lg overflow-hidden" style={{
        border: '2px solid #E5E5E5'
      }} data-id="element-630" data-mp="3p7zb95rvnh3r" data-mpi={index}>
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-300" loading="lazy" data-id="element-631" data-mp="1nfulo0xuovw7" />
          </div>)}
      </div>

      <div className="container mx-auto px-4 mt-8 text-center" data-id="element-632" data-mp="1zwdkh9tqx693">
        <a href="/gallery" data-id="element-633" data-mp="24nvh5loqkko9">
          <button className="px-8 py-3 rounded-md font-bold transition-all hover:opacity-90" style={{
          backgroundColor: '#FFFFFF',
          color: '#0B1F3F',
          border: '2px solid #0B1F3F'
        }} data-id="element-634" data-mp="24nlry0bimhjm">
            View Full Gallery
          </button>
        </a>
      </div>
    </section>;
};